import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField, FormFields } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { getCurrentRestBpm } from '../actions';
import { selectWork } from '../../Api/selectors';
import { GET_CURRENT_REST_BPM } from '../constants';
import { Loader } from '../../../components/Loader';
import { selectAutotelexBPM } from '../selectors';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const STATE = {
  value: null,
};

/* eslint-disable react/prefer-stateless-function */
class OutgoingBPMModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.getCurrentRestBpm(this.vehicleId);
  }

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  applySelection() {
    this.props.addInvoiceRelation(this.state.selectedInvoice.id, this.reset.bind(this));
  }

  get disableApplyBtn() {
    return !!isNaN(this.value);
  }

  onConfirm() {
    this.props.onConfirm(this.value);
  }

  onCancel() {
    this.props.onCancel();
  }

  get vehicleId() {
    const targetSubject = this.props.invoice.invoiceSubjects.find(s => ['vehicle', 'BPM'].includes(s.type));
    return targetSubject?.vehicleId;
  }

  get oldValue() {
    const targetSubject = this.props.invoice.invoiceSubjects.find(s => ['vehicle', 'BPM'].includes(s.type));
    return targetSubject?.outgoing_rest_bpm;
  }

  get autotelexValue() {
    return this.props?.fetchedBPM?.autotelexRestBpm;
  }

  get value() {
    return this.state.value !== null ? this.state.value : this.autotelexValue;
  }

  render() {
    if (this.props.work)
      return (
        <ModalComponent onClose={this.onCancel.bind(this)} title={this.lbl(`Updating of current rest bpm`)}>
          <Loader small />
        </ModalComponent>
      );

    return (
      <ModalComponent onClose={this.onCancel.bind(this)} title={this.lbl(`Updating of current rest bpm`)}>
        <FormFields>
          <FormField label={this.lbl('currentValue')}>
            <input className="form-control" name="oldValue" value={this.oldValue} disabled={true} />
          </FormField>
          <FormField label={this.lbl('autotelexValue')}>
            <input className="form-control" name="autotelexValue" value={this.autotelexValue} disabled={true} />
          </FormField>
          <FormField label={this.lbl('update with value')}>
            <input className="form-control" name="value" value={this.value} onChange={this.onInputChange.bind(this)} />
          </FormField>
        </FormFields>
        <div className="d-flex">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            onClick={this.onConfirm.bind(this)}
            primary
            disabled={this.disableApplyBtn}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

OutgoingBPMModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(GET_CURRENT_REST_BPM),
    fetchedBPM: selectAutotelexBPM(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getCurrentRestBpm(vehicleId) {
      dispatch(getCurrentRestBpm(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingBPMModal = compose(withConnect, withRouter)(OutgoingBPMModalComp);
